import React from "react";
import { useHistory } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const TRIP_TYPES = [
  {
    key: "business",
    badge: "Business",
    title: "For Business Trips",
    image: "/figma-assets/stay/business-travel.jpg",
    alt: "Business travel",
    shade: "linear-gradient(0deg, rgba(1,45,110,0.9) 0%, rgba(1,45,110,0.4) 50%, rgba(1,45,110,0) 100%)",
    badgeClass: "bg-[#017bef]",
    dotClass: "bg-[#60a5fa]",
    items: ["Business travellers", "Work trips", "Relocations", "Extended assignments"],
    cta: "Explore Business Stays",
    // The search page has no purpose filter, so both cards open the Stay search
    to: "/workspaces-search?type=stay&categoryId=2",
  },
  {
    key: "leisure",
    badge: "Leisure",
    title: "For Personal Travel",
    image: "/figma-assets/stay/intro-boutique.jpg",
    alt: "Leisure travel",
    shade: "linear-gradient(0deg, rgba(10,10,10,0.85) 0%, rgba(10,10,10,0.3) 50%, rgba(10,10,10,0) 100%)",
    badgeClass: "border-[1px] border-solid border-white/30 bg-white/20",
    dotClass: "bg-[#ffd230]",
    items: ["Holidays", "Personal travel", "Weekend stays", "Experiences"],
    cta: "Explore Leisure Stays",
    to: "/workspaces-search?type=stay&categoryId=2",
  },
];

export default function StayYourWay() {
  const history = useHistory();

  return (
    <section className="bg-white py-20">
      <div className="mx-auto max-w-[1440px] px-[16px] sm:px-8">
        <p className="text-center text-[14px] font-semibold uppercase leading-5 tracking-[1.4px] text-[#017bef]">
          For Everyone
        </p>
        <h2 className="pt-[12px] text-center text-[36px] font-bold leading-[1.2] tracking-[-1.2px] text-[#0a0a0a] sm:text-[48px] sm:leading-[48px]">
          Stay Your Way
        </h2>

        <div className="grid grid-cols-1 gap-6 pt-14 lg:grid-cols-2">
          {TRIP_TYPES.map(trip => (
            <div key={trip.key} className="relative flex min-h-[440px] items-end overflow-hidden rounded-3xl">
              <img src={trip.image} alt={trip.alt} className="absolute inset-0 size-full object-cover" />
              <div className="absolute inset-0" style={{ backgroundImage: trip.shade }} />
              <div className="relative p-8">
                <span
                  className={`inline-block rounded-full px-[12px] py-1 text-[10px] font-bold uppercase leading-[15px] tracking-[1px] text-white ${trip.badgeClass}`}
                >
                  {trip.badge}
                </span>
                <h3 className="pt-[16px] text-[24px] font-bold leading-8 text-white">{trip.title}</h3>
                <ul className="space-y-2 pb-6 pt-[16px]">
                  {trip.items.map(item => (
                    <li key={item} className="flex items-center gap-2 text-[14px] leading-5 text-white/70">
                      <span className={`size-1.5 shrink-0 rounded-full ${trip.dotClass}`} />
                      {item}
                    </li>
                  ))}
                </ul>
                <button
                  type="button"
                  onClick={() => history.push(trip.to)}
                  className="inline-flex items-center gap-2 text-[14px] font-semibold leading-5 text-white/80 hover:text-white"
                >
                  {trip.cta}
                  <ArrowRight className="size-3.5" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
